
import "../Foundation/stylable/colors.st.css.js";
import "../Text/Text.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_76_1_Breadcrumbs";
var _style_ = /*#__PURE__*/ classesRuntime.bind(null, _namespace_);

export var cssStates = /*#__PURE__*/ statesRuntime.bind(null, _namespace_);
export var style = /*#__PURE__*/ _style_;
export var st = /*#__PURE__*/ _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_76_1_Breadcrumbs__root","breadcrumbsHover":"wds_1_76_1_Breadcrumbs__breadcrumbsHover","breadcrumbs":"wds_1_76_1_Breadcrumbs__breadcrumbs","item":"wds_1_76_1_Breadcrumbs__item","itemContainer":"wds_1_76_1_Breadcrumbs__itemContainer","divider":"wds_1_76_1_Breadcrumbs__divider"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"color":"var(--wsr-color-D30, #577083)","backgroundColor":"var(--wsr-color-D80, #FFFFFF)","height":"36px","sidePadding":"14px"}; 
export var vars = {}; 




